function header() {
  const c = {
    dom: {
      header: 'section-header',
      menu_dropdown: 'js-nav-item',
      menu_dropdown_btn: 'js-menu-link-btn',
      menu: 'js-dropdown-menu',
      menu_item: 'js-link-item',
      aria_expanded: 'aria-expanded',
      aria_hidden: 'aria-hidden',
      popup: 'js-has-popup',
    },
    cls: {
      active: 'is-active',
      expanded: 'is-expanded',
    },
    event: {
      click: 'click',
      keydown: 'keydown',
      focus: 'focus',
      blur: 'blur',
    },
    color: {
      black: '#000',
      transparent: 'transparent',
    },
  };

  function init() {
    addEvents();
  }

  /**
   * add events
   */
  function addEvents() {
    // ADA - opens Header menu by keyboard
    _.addEvent({
      id: c.dom.header,
      className: c.dom.menu_dropdown_btn,
      event: c.event.keydown,
      fn: menuTrigger,
    });

    // Handle focus and blur for menu_dropdown_btn to change color even without opening the menu
    _.addEvent({
      id: c.dom.header,
      className: c.dom.menu_dropdown_btn,
      event: c.event.focus,
      fn: handleFocus,
    });

    _.addEvent({
      id: c.dom.header,
      className: c.dom.menu_dropdown_btn,
      event: c.event.blur,
      fn: handleBlur,
    });

    _.addEvent({
      id: c.dom.header,
      className: c.dom.popup,
      event: c.event.keydown,
      fn: menuTrigger,
    });
  }

  /**
   * For ADA - Opens header menu by keyboard
   * @param e keyboard targeted element
   */
  function menuTrigger(e) {
    const enter = e.keyCode === 13;

    // Use e.composedPath() if available, otherwise fallback to a custom path builder
    const path = e.composedPath ? e.composedPath() : getPath(e.target);

    const keyboardLink = enter && _.hasClass(path[1], c.dom.menu_dropdown);
    const keyboardSublink = enter && _.hasClass(path[1], c.dom.popup);

    if (keyboardLink || keyboardSublink) {
      const currentTab = path[1];
      const menu = currentTab.querySelector(`.${c.dom.menu}`);

      e.preventDefault();
      openMenu(e, menu);
    } else if (enter) {
      window.location.href = e.target.href;
    }
  }

  // Fallback function to build the event path manually
  function getPath(target) {
    const path = [];
    while (target.parentNode !== null) {
      path.push(target);
      target = target.parentNode;
    }
    path.push(document, window);
    return path;
  }

  /**
   * Handle focus for menu_dropdown_btn
   * Changes color when focused, even without opening the menu
   */
  function handleFocus(e) {
    const menuLink = e.target;
    menuLink.style.color = c.color.black;
  }

  /**
   * Handle blur for menu_dropdown_btn
   * Changes color back to transparent when losing focus, only if menu is not expanded
   */
  function handleBlur(e) {
    const menuLink = e.target;
    const tabMenu = menuLink.closest(`.${c.dom.menu_dropdown}`);

    // Only set to transparent if the menu is NOT expanded
    if (!_.hasClass(tabMenu, c.cls.expanded) && !_.hasClass(menuLink, c.dom.menu_item)) {
      menuLink.style.color = c.color.transparent;
    }
  }

  /**
   * ADA - keyboard toggle menu
   * @param element keyboard targeted element
   * @param menu current dropdown menu
   */
  function openMenu(event, menu) {
    const path = event.composedPath ? event.composedPath() : getPath(event.target);
    const tabMenu = path.find((el) => _.hasClass(el, c.dom.menu_dropdown) || _.hasClass(el, c.dom.popup)) || path[1];
    const menuLink = event.target;
    const menuItem = menu.querySelector(`.${c.dom.menu_item}`);
    const $prevActiveElement = document.activeElement;

    // Change the color when the menu opens and the link is focused
    menuLink.style.color = c.color.black;
    menuLink.setAttribute(c.dom.aria_expanded, 'true');

    _.addClass(tabMenu, c.cls.expanded);
    menu.setAttribute(c.dom.aria_hidden, 'false');

    menuLink.addEventListener('blur', () => {
      // Set the color to transparent only if the menu is not expanded
      if (!_.hasClass(tabMenu, c.cls.expanded)) {
        if (!_.hasClass(menuLink, c.dom.menu_item)) {
          menuLink.style.color = c.color.transparent;
        }
        menuLink.setAttribute(c.dom.aria_expanded, 'false');
      }
    });

    setTimeout(() => {
      menuItem.focus();

      // Handle ESC key to close the menu
      const handleKeydown = (e) => {
        const escKey = e.keyCode === 27;

        if (escKey) {
          closeMenu();
          $prevActiveElement.focus();
          document.removeEventListener('keydown', handleKeydown);
          document.removeEventListener('focusin', handleFocusin);
        }
      };
      document.addEventListener('keydown', handleKeydown);

      // Handle focusin to close the menu if focus leaves the menu
      const handleFocusin = (e) => {
        if (!menu.contains(e.target) && !tabMenu.contains(e.target)) {
          closeMenu();
          document.removeEventListener('focusin', handleFocusin);
        }
      };
      document.addEventListener('focusin', handleFocusin);

      // Function to close the menu
      function closeMenu() {
        _.removeClass(tabMenu, c.cls.expanded);
        menuLink.setAttribute(c.dom.aria_expanded, 'false');
        menu.setAttribute(c.dom.aria_hidden, 'true');
        if (!_.hasClass(menuLink, c.dom.menu_item)) {
          menuLink.style.color = c.color.transparent;
        }
      }
    }, 250);
  }

  return init();
}

header();
